<template>
  <b-container>
    <b-row class="mt-4">
      <b-col>
        <Navigation targetPageValue="BuildingList" :targetPageName="$t('title.buildingManagement')"
          v-on:changePage="setNextPage" />
      </b-col>
    </b-row>
    <h1 class="text-center pt-4 pb-4">{{ existingBuilding ? $t("action.editBuilding") : $t("action.addBuilding") }}</h1>

    <b-form @submit="onSubmit">

      <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio v-model="buildingStatus" :aria-describedby="ariaDescribedby" name="status-radios" value="1"
          :disabled="existingBuilding">Crm (All)</b-form-radio>
        <b-form-radio v-model="buildingStatus" :aria-describedby="ariaDescribedby" name="status-radios" value="3"
          :disabled="existingBuilding">Planner (Only)</b-form-radio>
      </b-form-group>

      <!--
        <b-row>
        <b-col>
          <b-form-checkbox class="mt-4" v-model="newBuilding" name="newBuilding" switch>{{ $t("label.newBuilding")
          }}</b-form-checkbox>
        </b-col>
      </b-row>
      -->
      <b-row>
        <b-col sm="4" class="mt-4">
          <b-form-input v-model.trim="$v.buildname.$model" :placeholder="$t('action.chooseName')"></b-form-input>
          <div class="text-danger" v-if="!$v.buildname.required && $v.buildname.$dirty">{{ $t("info.required") }}</div>
          <div class="text-danger" v-if="!$v.buildname.maxLength && $v.buildname.$dirty">{{ $t("info.maxLength", [50])
          }}
          </div>
        </b-col>
      </b-row>

      <b-row v-if="buildingStatus && buildingStatus == 1">
        <b-col sm="4" class="mt-4">
          <b-form-input v-model.trim="$v.RatioS.$model" placeholder="RatioS"></b-form-input>
          <div class="text-danger" v-if="!$v.RatioS.required && $v.RatioS.$dirty">{{ $t("info.required") }}</div>
          <div class="text-danger" v-if="!$v.RatioS.decimal && $v.RatioS.$dirty">{{ $t("info.integer") }}</div>
          <div class="text-danger" v-if="!$v.RatioS.maxLength && $v.RatioS.$dirty">{{ $t("info.maxLength", [5]) }}</div>
          <div class="text-danger" v-if="!$v.RatioS.minValue && $v.RatioS.$dirty">{{ $t("info.minLength", [1]) }}</div>
        </b-col>
      </b-row>

      <b-row v-if="existingBuilding === false && buildingStatus && buildingStatus == 1">
        <b-col sm="4" class="mt-4">
          <b-form-input v-model.trim="$v.NOCIE.$model" placeholder="NOCIE" :readonly="buildingValidate"></b-form-input>
          <div class="text-danger" v-if="!$v.NOCIE.required && $v.NOCIE.$dirty">{{ $t("info.required") }}</div>
          <div class="text-danger" v-if="!$v.NOCIE.integer && $v.NOCIE.$dirty">{{ $t("info.integer") }}</div>
          <div class="text-danger" v-if="!$v.NOCIE.maxLength && $v.NOCIE.$dirty">{{ $t("info.maxLength", [5]) }}</div>
        </b-col>
      </b-row>
      <b-row v-if="existingBuilding === false && buildingStatus && buildingStatus == 1">
        <b-col sm="4" class="mt-4">
          <b-form-input v-model.trim="$v.NODIV.$model" placeholder="NODIV" :readonly="buildingValidate"></b-form-input>
          <div class="text-danger" v-if="!$v.NODIV.required && $v.NODIV.$dirty">{{ $t("info.required") }}</div>
          <div class="text-danger" v-if="!$v.NODIV.integer && $v.NODIV.$dirty">{{ $t("info.integer") }}</div>
          <div class="text-danger" v-if="!$v.NODIV.maxLength && $v.NODIV.$dirty">{{ $t("info.maxLength", [5]) }}</div>
        </b-col>
      </b-row>

      <b-modal id="deleteModal" :title="$t('title.confirmation')" hide-footer>
        <DeleteBuildingConfirmation :NOMDIV="buildname" :Id="Id" :NOCIE="NOCIE" :NODIV="NODIV" modalid="deleteModal" />
      </b-modal>

      <div v-if="existingBuilding">
        <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit") }}</b-button>
        <b-button class="mt-4 mr-4 float-right" variant="danger" @click="openmodal('deleteModal')">{{
          $t("action.remove")
        }}</b-button>
      </div>

      <div v-if="existingBuilding === false && buildingStatus && buildingStatus == 1">
        <b-button class="mt-4" variant="success" :disabled="disabledVal" @click="validateBuilding()">{{
          $t("action.validate") }}</b-button>

        <div class="mt-4" v-if="buildingValidate">
          <b-alert show variant="warning">
            <div>NOMDIV : {{ infoBuilding.NOMDIV }} </div>
            <div>NOCIE : {{ infoBuilding.NOCIE }} </div>
            <div>NODIV : {{ infoBuilding.NODIV }} </div>
          </b-alert>

          <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit")
          }}</b-button>
          <b-button class="mt-4 ml-2" type="submit" variant="danger" @click="resetField()">{{ $t("action.reset")
          }}</b-button>
        </div>
      </div>

      <div v-if="existingBuilding === false && buildingStatus && buildingStatus == 3">
        <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit") }}</b-button>
        <b-button class="mt-4 ml-2" type="submit" variant="danger" @click="resetField()">{{ $t("action.reset")
          }}</b-button>
      </div>

    </b-form>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.successgeneric") }}</p>
      </b-alert>
    </div>

    <div v-if="errorfields" class="pt-4">
      <b-alert show variant="warning">
        <p>{{ errorfields }}</p>
      </b-alert>
    </div>

    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>
    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>

  </b-container>
</template>

<script>
import axios from 'axios';
import { required, maxLength, integer, decimal, minValue } from 'vuelidate/lib/validators';
import DeleteBuildingConfirmation from './DeleteBuildingConfirmation.vue';
import Navigation from '../../Navigation.vue';

import { globalF } from '../../Helpers';

export default {
  mixins: [globalF],
  data() {
    return {
      Id: 0,
      NOCIE: "",
      NODIV: "",
      buildname: "",
      success: false,
      errorfields: "",
      error: "",
      disabled: false,
      disabledVal: false,
      spinner: false,
      existingBuilding: false,
      buildingValidate: false,
      infoBuilding: [],
      RatioS: null,
      newBuilding: false,
      buildingStatus: "1"
    }
  },
  validations() {
    if (this.buildingStatus && this.buildingStatus == 3) {
      return {
        buildname: {
          required,
          maxLength: maxLength(50)
        }
      }
    }
    else {
      return {
        NOCIE: {
          required,
          integer,
          maxLength: maxLength(5)
        },
        NODIV: {
          required,
          integer,
          maxLength: maxLength(5)
        },
        buildname: {
          required,
          maxLength: maxLength(50)
        },
        RatioS: {
          required,
          decimal,
          minValue: minValue(1),
          maxLength: maxLength(5)
        }
      }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      let reloadvalue = this.$store.getters.getReload;
      if (reloadvalue) {
        this.$store.commit('setReloadValue', true);
        this.$emit('changePage', 'BuildingList');
      }
    });

    let build = this.$store.getters.getBuildingToEdit;
    if (build) {
      this.Id = build.Id;
      this.NOCIE = build.NOCIE;
      this.NODIV = build.NODIV;
      this.buildname = build.NOMDIV;
      this.RatioS = build.RatioS;
      this.newBuilding = false;
      this.existingBuilding = true;
      this.buildingStatus = build.Status;
    }
  },
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
    isHopem: function () {
      let build = this.$store.getters.getBuildingToEdit;
      if ((this.NOCIE == 0 && this.NODIV == 0) || (build && build.Status == 3)) {
        return true;
      }
      else {
        return false;
      }
    }
  },
  methods: {
    setNextPage(page) {
      this.$emit('changePage', page);
    },
    openmodal: function (id) {
      this.$bvModal.show(id);
      this.$store.commit('addUserToEdit', null);
    },
    validateBuilding: function () {
      this.error = "";
      this.errorfields = "";
      this.success = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disabledVal = true;
        this.spinner = true;

        let obj = {
          Id: this.Id,
          NOCIE: this.NOCIE,
          NODIV: this.NODIV,
          buildname: this.buildname,
          existingBuilding: this.existingBuilding,
        }

        let promise = this.validateToken();
        promise.then(() => {

          axios.post(this.url, { request: "validateBuildingInfo", form: obj }, { headers: { 'Content-Type': 'application/json' } })
            .then((response) => {
              this.disabledVal = false;
              this.spinner = false;
              let res = response.data;
              if (res === "nobuilding") { this.errorfields = this.$t('info.nobuilding'); }
              else if (res === "buildingexist") { this.errorfields = this.$t('info.buildingExist'); }
              else {
                this.buildingValidate = true;
                this.disabledVal = true;
                this.infoBuilding = res[0];
              }
            })
            .catch(() => {
              this.spinner = false;
              this.error = this.$t('info.errorgeneric');
              this.disabled = false;
            });

        });

      }

    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.errorfields = "";
      this.success = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disabled = true;
        this.spinner = true;

        let request = "addBuilding";
        let obj = {
          Id: this.Id,
          NOCIE: this.NOCIE,
          NODIV: this.NODIV,
          RatioS: parseFloat(this.RatioS),
          new: 0,
          buildname: this.buildname,
          existingBuilding: this.existingBuilding,
          buildingStatus: parseInt(this.buildingStatus)
        }

        if (this.buildingStatus == 3) {
          request = "addPlannerBuilding";
          obj.NOCIE = 0;
          obj.NODIV = 0;
          obj.RatioS = 3;
        }

        /*Ajax Call*/
        axios.post(this.url, { request: request, form: obj }, { headers: { 'Content-Type': 'application/json' } })
          .then((response) => {
            this.disabled = false;
            this.spinner = false;
            let res = response.data;
            if (res === "nobuilding") { this.errorfields = this.$t('info.nobuilding'); }
            else if (res === "buildingexist") { this.errorfields = this.$t('info.buildingExist'); }
            else {
              this.$emit('changePage', 'BuildingList');
            }
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t('info.errorgeneric');
            this.disabled = false;
          });
      }
    },
    resetField: function () {
      this.$v.$reset();
      this.Id = 0,
        this.NOCIE = "",
        this.NODIV = "",
        this.RatioS = null,
        this.buildname = "",
        this.success = false,
        this.errorfields = "",
        this.error = "",
        this.disabled = false,
        this.disabledVal = false,
        this.spinner = false,
        this.buildingValidate = false,
        this.infoBuilding = []
    }
  },
  components: {
    DeleteBuildingConfirmation,
    Navigation
  }
}
</script>
